// extracted by mini-css-extract-plugin
export default {"root":"ModalMark_root__w+pCZ","question":"ModalMark_question__gy9sI","success":"ModalMark_success__aplom","error":"ModalMark_error__9UwEu","icon":"ModalMark_icon__-VMa1"};